'use client';
import ChevronDown from '@/assets/svgs/chevron-down.svg';
import { inter500 } from '@/config/fonts';
import { loseFocusFromActiveElement } from '@/shared/utils/dom';
import { textEditorFonts } from '@/shared/utils/text-editor';
import classNames from 'classnames';
import { TextEditorFont } from '../types';

interface FontSelectionDropdownButtonProps {
  className?: string;
  selectedFont?: TextEditorFont;
  onChange?: (font: TextEditorFont) => void;
}

const FontSelectionDropdownButton = ({
  className,
  selectedFont,
  onChange,
}: FontSelectionDropdownButtonProps) => {
  return (
    <div className={classNames('dropdown', className)} data-dropdown-dismiss="true">
      <div
        tabIndex={0}
        role="button"
        className={classNames(
          'btn btn-ghost text-gray-default m-1 mr-0 flex !h-8 min-w-[77px] justify-between border-transparent !pr-1 !pl-2 !text-[13px]',
          inter500.className
        )}>
        {selectedFont?.label}
        <ChevronDown className="text-neutral-default" />
      </div>
      <ul
        tabIndex={0}
        className="menu dropdown-content rounded-box bg-base-100 max-h-52 w-52 flex-nowrap overflow-auto border border-transparent p-2 shadow dark:border-gray-800">
        {textEditorFonts.map((font, idx) => {
          return (
            <li key={idx}>
              <span
                onMouseDown={(e) => {
                  e.preventDefault(); // Prevent menu item from stealing focus from editor
                }}
                onClick={() => {
                  loseFocusFromActiveElement();
                  onChange?.(font);
                }}>
                {font.label}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FontSelectionDropdownButton;
